import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { AdsGETApiAuth, AdsPUTApi } from "../../../Constant/api";
import { slugs } from "../../../Constant/slugs";
const columns = [
  {
    id: 1,
    name: "id",
    selector: (row) => row.id,
    sortable: true,
    reorder: true,
    width: "100px"
  },
  {
    id: 31,
    name: "Title",
    selector: (row) => row.title.rendered,
    sortable: true,
    reorder: true
  },
  {
    id: 312,
    name: "Phone",
    selector: (row) => row.meta.user_phone_number,
    sortable: true,
    reorder: true
  },
  {
    id: 313,
    name: "Email",
    selector: (row) => row.meta.user_email,
    sortable: true,
    reorder: true
  },
  {
    id: 32,
    name: "Verification for",
    selector: (row) => row.meta.exam_verification_list.replace(",", ""),
    sortable: true,
    reorder: true
  },
  // {
  //   id: 32,
  //   name: "Device ID",
  //   selector: (row) => row.meta.device_id,
  //   sortable: true,
  //   reorder: true
  // },
  {
    id: 3,
    name: "View",
    right: true,
    cell: (row) => <Link to={`${slugs.student_details}${row.slug}`}>View</Link>,

  }
];

export default function AllStudents() {
  const [Projects1, setProjects1] = React.useState([])
  const [Projects2, setProjects2] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const [SubscriberTotal, setSubscriberTotal] = React.useState(0)
  const [StudentTotal, setStudentTotal] = React.useState(0)
  const [AdminTotal, setAdminTotal] = React.useState(0)
  const [AllTotal, setAllTotal] = React.useState(0)
  const [serachName, setSearchName] = React.useState("")
  const [serachEmail, setSearchEmail] = React.useState("")
  const [serachPhone, setSearchPhone] = React.useState("")
  const [searchPhoneAct, setSearchPhoneAct] = React.useState(0)

  const [bulkDelete, setBulkDelete] = React.useState(false)
  const GetTotal = (Role, setDataLength, all) => {
    setReload(true)
    setProjects1([])
    const allT = !all ? {
      "filter[meta_query][1][key]": "user_role",
      "filter[meta_query][1][value][0]": `${Role}`,
      "filter[meta_query][1][compare]": "=",
      per_page: 1
    } : { per_page: 1 }
    AdsGETApiAuth(allT, slugs.db_slug_user_data)
      .then((res) => {
        setDataLength(res.headers["x-wp-total"])
        console.log("done")
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        // setReload(false)
      })
  }
  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(params, slugs.db_slug_user_data)
      .then((res) => {
        setProjects1(res.data)
        setCustomersList(res.data)
        console.log("done")
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  useEffect(() => {
    GetAllProjects({
      per_page: 20000,
      _fields: "id,title,meta,slug"
    })
    GetTotal("subscriber", setSubscriberTotal, false)
    GetTotal("student", setStudentTotal, false)
    GetTotal("author", setAdminTotal, false)
    GetTotal("all", setAllTotal, true)

  }, [])
  var ExamVerificationList2 = [];
  const CustomButton2 = ({ DataValue }) => {
    const [find, setFind] = React.useState(ExamVerificationList2.includes(DataValue))
    return (
      <div
        onClick={() => {

          if (find) {
            for (let i in ExamVerificationList2)
              if (ExamVerificationList2[i] == DataValue)
                ExamVerificationList2.splice(i, 1)
            setFind(false)
          }
          else {
            ExamVerificationList2.push(DataValue)
            setFind(true)
          }
          console.log(ExamVerificationList2)
        }}
      >

        {
          find ?
            <i className="fa fa-check-square-o" />
            :
            <i className="fa fa-square-o" />
        }
        &nbsp; {DataValue}
      </div >
    )
  }
  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>All Students</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Students
        </div>
      </div>
      <a href={slugs.new_student}>
        <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}
          onClick={() => {

          }}
        >Add New Student</div>
      </a>
      <div className="row">
        <div className="col-md-5">
          <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setProjects1(CustomersList)
                GetAllProjects({
                  per_page: 100,
                  _fields: "id,title,meta,slug"
                })
              }}
            >
              All ({AllTotal}) |
            </div>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setProjects1(CustomersList.filter(a => a.meta.exam_verification_list == ""))
              }}
            >
              Unverified ({CustomersList.filter(a => a.meta.exam_verification_list == "").length}) |
            </div>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setProjects1(CustomersList.filter(a => a.meta.exam_verification_list !== ""))
              }}
            >
              Verified ({CustomersList.filter(a => a.meta.exam_verification_list !== "").length}) |
            </div>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setProjects1(CustomersList.filter(a => a.meta.user_role == "author"))
              }}
            >
              Admin ({AdminTotal}) |
            </div>
            <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}>
              {Projects2.length == 0 ?
                <div />
                :
                <div
                  onClick={() => {
                    setBulkDelete(true)
                  }}
                >
                  Bulk Update
                </div>
              }
            </div>
          </div>
        </div>
        <div className="col-md-7 row">
          {/* <div className="col-4" /> */}
          <input className="col-2" style={{ margin: "1px 2px", padding: "3px 2px" }}
            value={serachName} placeholder="Name"
            onChange={(event) => {
              setSearchName(event.target.value)
              setSearchPhoneAct(0)
              setProjects1(CustomersList.filter(a => a.meta.user_name.includes(event.target.value)))
            }}
          />
          <input className="col-3" style={{ margin: "1px 2px", padding: "3px 2px" }}
            value={serachEmail} placeholder="Email"
            onChange={(event) => {
              setSearchEmail(event.target.value)
              setSearchPhoneAct(1)
              setProjects1(CustomersList.filter(a => a.meta.user_email.includes(event.target.value)))
            }}
          />
          <input className="col-2" style={{ margin: "1px 2px", padding: "3px 2px" }}
            value={serachPhone} placeholder="Phone"
            onChange={(event) => {
              setSearchPhone(event.target.value)
              setSearchPhoneAct(2)
              setProjects1(CustomersList.filter(a => a.meta.user_phone_number.includes(event.target.value)))
            }}
          />
          <div className="col-2" style={{ cursor: "pointer" }}
            onClick={() => {
              if (searchPhoneAct == 0)
                GetAllProjects({
                  per_page: 200,
                  _fields: "id,title,slug,meta",
                  "filter[meta_query][1][key]": "user_name",
                  "filter[meta_query][1][value][0]": serachName,
                  "filter[meta_query][1][compare]": "=",
                }, slugs.db_slug_user_data)
              else if (searchPhoneAct == 1)
                GetAllProjects({
                  per_page: 200,
                  _fields: "id,title,slug,meta",
                  "filter[meta_query][1][key]": "user_email",
                  "filter[meta_query][1][value][0]": serachEmail,
                  "filter[meta_query][1][compare]": "=",
                }, slugs.db_slug_user_data)
              else
                GetAllProjects({
                  per_page: 200,
                  _fields: "id,title,slug,meta",
                  "filter[meta_query][1][key]": "user_phone_number",
                  "filter[meta_query][1][value][0]": serachPhone,
                  "filter[meta_query][1][compare]": "=",
                }, slugs.db_slug_user_data)
            }}
          >
            {searchPhoneAct == 0 ?
              "Search Name"
              : searchPhoneAct == 1 ? "Search Email" : "Search Phone"
            }
          </div>
        </div>
      </div>

      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        <DataTable
          columns={columns}
          data={Projects1}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          striped
          // sortIcon={<SortIcon />}
          pagination
          selectableRows
          onSelectedRowsChange={(r) => {
            console.log("asdasd", r)
            setProjects2(r.selectedRows)
          }}
        />
      </div>
      {Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {bulkDelete &&
        <section className="modal" >
          <div className="row">
            <div className="col-md-4 col-1"></div>
            <div className="col-md-4 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'scroll', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setBulkDelete(false)
                  }}
                >X</div>
                Do you really want to Update all the select students?<br />
                <tr>
                  <td className="col-3">Verification For</td>
                  <td className="col-6">
                    <CustomButton2 DataValue={"UBT"} />
                    <CustomButton2 DataValue={"CBT"} />
                    <CustomButton2 DataValue={"TextBook"} />
                    <CustomButton2 DataValue={"Video"} />
                    <CustomButton2 DataValue={"LJDExam"} />
                    <CustomButton2 DataValue={"LJDPembahasan"} />
                  </td>
                </tr>
                <tr>
                  <td colSpan={6}>
                    <div className="row">
                      <div className="col-1" />
                      <div className="col-5 center " >
                        <div className="sign-in-button-4" style={{ width: "80%" }}
                          onClick={() => {
                            setBulkDelete(false)
                          }}
                        >
                          Cancel
                        </div>
                      </div>
                      <div className="col-5 center">
                        <div className="sign-in-button-4" style={{ width: "80%" }}
                          onClick={() => {
                            setBulkDelete(false)
                            for (let i = 0; i < Projects2.length; i++) {
                              setReload(true)
                              AdsPUTApi({
                                meta: {
                                  "exam_verification_list": ExamVerificationList2.toString()
                                }
                              }, slugs.db_slug_user_data, Projects2[i].id)
                                .then((res) => {
                                  if (i == Projects2.length - 1) {
                                    GetAllProjects({
                                      per_page: 4999,
                                      _fields: "id,title,meta,slug"
                                    })
                                  }
                                })
                                .catch((err) => {
                                  console.log(err)
                                })

                            }
                          }}
                        >
                          Update All
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </div>
            </div>
          </div>
        </section>

      }
    </div>
  )

}